import { ComumService } from './../../comum/comum.service';
import { Evento } from './../../comum/eventos/evento';
import { ClienteService } from './../cliente.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Cliente } from '../../comum/modelos/cliente';
import { Component, OnInit } from '@angular/core';
import { CookieService } from 'angular2-cookie/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
	selector: 'app-listar-clientes',
	templateUrl: './listar-clientes.component.html',
	styleUrls: ['./listar-clientes.component.css']
})
export class ListarClientesComponent implements OnInit {

	public filtroPesquisaRazaoSocialBind: string;

	public clientes: Cliente[];

	public paginacao: Paginacao;

	public evento: Evento;

	public loading = false;
	public statusCode: number;

	constructor(private _clienteService: ClienteService,
		private _cookieService: CookieService,
		private _comumService: ComumService,
		private _authService: AuthService,
		private router: Router) {

		this.paginacao = new Paginacao();

		this.evento = this._comumService.evento;

		if (this.evento !== undefined) {
			setTimeout(() => {
				this._comumService.cleanEvent();
			}, 3000);
		}
	}

	ngOnInit() {
		this.loading = true;
		if (this._authService.isAdmin) {
			this._clienteService.obterClientesHttp()
				.subscribe((clientes: Cliente[]) => {
					this.clientes = clientes;
					this.loading = false;
				});
			this.paginacao.itens = 5;
			this.paginacao.page = 1;
		} else {
			const idCliente = this._cookieService.get('idCliente');
			this.loading = false;
			this.router.navigate(['/atualizar-cliente/' + idCliente]);
		}
	}

	pesquisarPorFiltro(filtro: any): void {
		this.filtroPesquisaRazaoSocialBind = filtro.value;
	}

	limparPesquisaPorFiltro(filtro: any): void {
		filtro.value = '';
		this.pesquisarPorFiltro(filtro);
	}

	removerCliente(cliente: Cliente): void {
		this.loading = true;
		this._clienteService.removerClienteHttp(cliente.idCliente)
			.subscribe(response => {
				this.loading = false;
				this.statusCode = response.status;
				this._comumService.evento.deletar = true;
			}, errorCode => {
				this.statusCode = errorCode;
				this.loading = false;
			});
		this._clienteService.removerCliente(this.clientes, cliente);

		setTimeout(() => {
			this.evento.limparEventos();
		}, 3000);

	}
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/cliente/listar-clientes/listar-clientes.component.ts